"use strict";
/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexerDeleteRequest = exports.IndexerUpsertRequest = exports.IndexerRequest = exports.SearchDocument = exports.GenericAutocompleteResponse = exports.GenericAutocompleteRequest = exports.GenericSearchResponse = exports.SearchResponseDocument = exports.KeyValuePair = exports.Resource = exports.Taxonomy = exports.Category = exports.Tag = exports.Image = exports.SearchResponseDocumentHighlights = exports.GenericSearchResponseFacets = exports.GenericSearchResponseFacetsCreatedItem = exports.TaxonomyCategory = exports.TaxonomyTag = exports.GenericSearchRequest = exports.GenericSearchRequestTaxonomyItem = void 0;
exports.GenericSearchRequestTaxonomyItem = {
    serializedName: 'GenericSearchRequest-taxonomyItem',
    type: {
        name: 'Composite',
        className: 'GenericSearchRequestTaxonomyItem',
        modelProperties: {
            tagId: {
                required: true,
                serializedName: 'tagId',
                type: {
                    name: 'String',
                },
            },
            categoryId: {
                required: true,
                serializedName: 'categoryId',
                type: {
                    name: 'String',
                },
            },
        },
    },
};
exports.GenericSearchRequest = {
    serializedName: 'GenericSearchRequest',
    type: {
        name: 'Composite',
        className: 'GenericSearchRequest',
        modelProperties: {
            index: {
                required: true,
                serializedName: 'index',
                type: {
                    name: 'String',
                },
            },
            query: {
                serializedName: 'query',
                type: {
                    name: 'String',
                },
            },
            skip: {
                serializedName: 'skip',
                constraints: {
                    InclusiveMinimum: 0,
                },
                type: {
                    name: 'Number',
                },
            },
            take: {
                serializedName: 'take',
                constraints: {
                    InclusiveMaximum: 100,
                    InclusiveMinimum: 0,
                },
                type: {
                    name: 'Number',
                },
            },
            parents: {
                serializedName: 'parents',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
            taxonomy: {
                serializedName: 'taxonomy',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'GenericSearchRequestTaxonomyItem',
                        },
                    },
                },
            },
            yearsCreated: {
                serializedName: 'yearsCreated',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Number',
                        },
                    },
                },
            },
            sort: {
                serializedName: 'sort',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
            highlightPreTag: {
                serializedName: 'highlightPreTag',
                type: {
                    name: 'String',
                },
            },
            highlightPostTag: {
                serializedName: 'highlightPostTag',
                type: {
                    name: 'String',
                },
            },
            takeFacets: {
                serializedName: 'takeFacets',
                constraints: {
                    InclusiveMaximum: 100,
                    InclusiveMinimum: 0,
                },
                type: {
                    name: 'Number',
                },
            },
        },
    },
};
exports.TaxonomyTag = {
    serializedName: 'TaxonomyTag',
    type: {
        name: 'Composite',
        className: 'TaxonomyTag',
        modelProperties: {
            title: {
                required: true,
                serializedName: 'title',
                type: {
                    name: 'String',
                },
            },
            id: {
                required: true,
                serializedName: 'id',
                type: {
                    name: 'String',
                },
            },
            categoryId: {
                required: true,
                serializedName: 'categoryId',
                type: {
                    name: 'String',
                },
            },
            count: {
                required: true,
                nullable: false,
                serializedName: 'count',
                type: {
                    name: 'Number',
                },
            },
        },
    },
};
exports.TaxonomyCategory = {
    serializedName: 'TaxonomyCategory',
    type: {
        name: 'Composite',
        className: 'TaxonomyCategory',
        modelProperties: {
            title: {
                serializedName: 'title',
                type: {
                    name: 'String',
                },
            },
            id: {
                serializedName: 'id',
                type: {
                    name: 'String',
                },
            },
            tags: {
                required: true,
                serializedName: 'tags',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'TaxonomyTag',
                        },
                    },
                },
            },
        },
    },
};
exports.GenericSearchResponseFacetsCreatedItem = {
    serializedName: 'GenericSearchResponse-facets-createdItem',
    type: {
        name: 'Composite',
        className: 'GenericSearchResponseFacetsCreatedItem',
        modelProperties: {
            count: {
                nullable: false,
                serializedName: 'count',
                type: {
                    name: 'Number',
                },
            },
            value: {
                serializedName: 'value',
                type: {
                    name: 'DateTime',
                },
            },
        },
    },
};
exports.GenericSearchResponseFacets = {
    serializedName: 'GenericSearchResponse-facets',
    type: {
        name: 'Composite',
        className: 'GenericSearchResponseFacets',
        modelProperties: {
            taxonomy: {
                serializedName: 'taxonomy',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'TaxonomyCategory',
                        },
                    },
                },
            },
            created: {
                serializedName: 'created',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'GenericSearchResponseFacetsCreatedItem',
                        },
                    },
                },
            },
        },
    },
};
exports.SearchResponseDocumentHighlights = {
    serializedName: 'SearchResponseDocument-highlights',
    type: {
        name: 'Composite',
        className: 'SearchResponseDocumentHighlights',
        modelProperties: {
            description: {
                serializedName: 'description',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
            content: {
                serializedName: 'content',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
            nestedContent: {
                serializedName: 'nestedContent',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
        },
    },
};
exports.Image = {
    serializedName: 'Image',
    type: {
        name: 'Composite',
        className: 'Image',
        modelProperties: {
            title: {
                required: true,
                serializedName: 'title',
                type: {
                    name: 'String',
                },
            },
            url: {
                required: true,
                serializedName: 'url',
                type: {
                    name: 'String',
                },
            },
            altText: {
                required: true,
                serializedName: 'altText',
                type: {
                    name: 'String',
                },
            },
            rank: {
                required: true,
                serializedName: 'rank',
                type: {
                    name: 'Number',
                },
            },
        },
    },
};
exports.Tag = {
    serializedName: 'Tag',
    type: {
        name: 'Composite',
        className: 'Tag',
        modelProperties: {
            id: {
                required: true,
                serializedName: 'id',
                type: {
                    name: 'String',
                },
            },
            title: {
                required: true,
                serializedName: 'title',
                type: {
                    name: 'String',
                },
            },
        },
    },
};
exports.Category = {
    serializedName: 'Category',
    type: {
        name: 'Composite',
        className: 'Category',
        modelProperties: {
            id: {
                required: true,
                serializedName: 'id',
                type: {
                    name: 'String',
                },
            },
            title: {
                required: true,
                serializedName: 'title',
                type: {
                    name: 'String',
                },
            },
        },
    },
};
exports.Taxonomy = {
    serializedName: 'Taxonomy',
    type: {
        name: 'Composite',
        className: 'Taxonomy',
        modelProperties: {
            tag: {
                required: true,
                serializedName: 'tag',
                type: {
                    name: 'Composite',
                    className: 'Tag',
                },
            },
            category: {
                required: true,
                serializedName: 'category',
                type: {
                    name: 'Composite',
                    className: 'Category',
                },
            },
        },
    },
};
exports.Resource = {
    serializedName: 'Resource',
    type: {
        name: 'Composite',
        className: 'Resource',
        modelProperties: {
            title: {
                required: true,
                serializedName: 'title',
                type: {
                    name: 'String',
                },
            },
            type: {
                required: true,
                serializedName: 'type',
                type: {
                    name: 'String',
                },
            },
            size: {
                required: true,
                serializedName: 'size',
                type: {
                    name: 'Number',
                },
            },
            url: {
                required: true,
                serializedName: 'url',
                type: {
                    name: 'String',
                },
            },
            rank: {
                required: true,
                serializedName: 'rank',
                type: {
                    name: 'Number',
                },
            },
        },
    },
};
exports.KeyValuePair = {
    serializedName: 'KeyValuePair',
    type: {
        name: 'Composite',
        className: 'KeyValuePair',
        modelProperties: {
            key: {
                required: true,
                serializedName: 'key',
                type: {
                    name: 'String',
                },
            },
            value: {
                required: true,
                serializedName: 'value',
                type: {
                    name: 'String',
                },
            },
        },
    },
};
exports.SearchResponseDocument = {
    serializedName: 'SearchResponseDocument',
    type: {
        name: 'Composite',
        className: 'SearchResponseDocument',
        modelProperties: {
            score: {
                serializedName: 'score',
                type: {
                    name: 'Number',
                },
            },
            highlights: {
                serializedName: 'highlights',
                type: {
                    name: 'Composite',
                    className: 'SearchResponseDocumentHighlights',
                },
            },
            id: {
                serializedName: 'id',
                type: {
                    name: 'String',
                },
            },
            title: {
                serializedName: 'title',
                type: {
                    name: 'String',
                },
            },
            description: {
                serializedName: 'description',
                type: {
                    name: 'String',
                },
            },
            content: {
                serializedName: 'content',
                type: {
                    name: 'String',
                },
            },
            url: {
                serializedName: 'url',
                type: {
                    name: 'String',
                },
            },
            created: {
                serializedName: 'created',
                type: {
                    name: 'DateTime',
                },
            },
            images: {
                serializedName: 'images',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'Image',
                        },
                    },
                },
            },
            readTime: {
                serializedName: 'readTime',
                type: {
                    name: 'Number',
                },
            },
            taxonomy: {
                serializedName: 'taxonomy',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'Taxonomy',
                        },
                    },
                },
            },
            linkedResources: {
                serializedName: 'linkedResources',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'Resource',
                        },
                    },
                },
            },
            customProperties: {
                serializedName: 'customProperties',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'KeyValuePair',
                        },
                    },
                },
            },
        },
    },
};
exports.GenericSearchResponse = {
    serializedName: 'GenericSearchResponse',
    type: {
        name: 'Composite',
        className: 'GenericSearchResponse',
        modelProperties: {
            count: {
                nullable: false,
                serializedName: 'count',
                type: {
                    name: 'Number',
                },
            },
            facets: {
                serializedName: 'facets',
                type: {
                    name: 'Composite',
                    className: 'GenericSearchResponseFacets',
                },
            },
            documents: {
                serializedName: 'documents',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'SearchResponseDocument',
                        },
                    },
                },
            },
        },
    },
};
exports.GenericAutocompleteRequest = {
    serializedName: 'GenericAutocompleteRequest',
    type: {
        name: 'Composite',
        className: 'GenericAutocompleteRequest',
        modelProperties: {
            index: {
                required: true,
                serializedName: 'index',
                type: {
                    name: 'String',
                },
            },
            query: {
                required: true,
                serializedName: 'query',
                type: {
                    name: 'String',
                },
            },
        },
    },
};
exports.GenericAutocompleteResponse = {
    serializedName: 'GenericAutocompleteResponse',
    type: {
        name: 'Composite',
        className: 'GenericAutocompleteResponse',
        modelProperties: {
            suggestions: {
                serializedName: 'suggestions',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
        },
    },
};
exports.SearchDocument = {
    serializedName: 'SearchDocument',
    type: {
        name: 'Composite',
        className: 'SearchDocument',
        modelProperties: {
            id: {
                required: true,
                serializedName: 'id',
                type: {
                    name: 'String',
                },
            },
            title: {
                serializedName: 'title',
                type: {
                    name: 'String',
                },
            },
            description: {
                serializedName: 'description',
                type: {
                    name: 'String',
                },
            },
            content: {
                serializedName: 'content',
                type: {
                    name: 'String',
                },
            },
            nestedContent: {
                serializedName: 'nestedContent',
                type: {
                    name: 'String',
                },
            },
            url: {
                serializedName: 'url',
                type: {
                    name: 'String',
                },
            },
            created: {
                serializedName: 'created',
                type: {
                    name: 'DateTime',
                },
            },
            images: {
                serializedName: 'images',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'Image',
                        },
                    },
                },
            },
            readTime: {
                serializedName: 'readTime',
                type: {
                    name: 'Number',
                },
            },
            taxonomy: {
                serializedName: 'taxonomy',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'Taxonomy',
                        },
                    },
                },
            },
            linkedResources: {
                serializedName: 'linkedResources',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'Resource',
                        },
                    },
                },
            },
            parents: {
                serializedName: 'parents',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
            customProperties: {
                serializedName: 'customProperties',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'KeyValuePair',
                        },
                    },
                },
            },
        },
    },
};
exports.IndexerRequest = {
    serializedName: 'IndexerRequest',
    type: {
        name: 'Composite',
        className: 'IndexerRequest',
        modelProperties: {
            indexName: {
                required: true,
                serializedName: 'indexName',
                type: {
                    name: 'String',
                },
            },
        },
    },
};
exports.IndexerUpsertRequest = {
    serializedName: 'IndexerUpsertRequest',
    type: {
        name: 'Composite',
        className: 'IndexerUpsertRequest',
        modelProperties: __assign(__assign({}, exports.IndexerRequest.type.modelProperties), { searchDocument: {
                required: true,
                serializedName: 'searchDocument',
                type: {
                    name: 'Composite',
                    className: 'SearchDocument',
                },
            } }),
    },
};
exports.IndexerDeleteRequest = {
    serializedName: 'IndexerDeleteRequest',
    type: {
        name: 'Composite',
        className: 'IndexerDeleteRequest',
        modelProperties: __assign(__assign({}, exports.IndexerRequest.type.modelProperties), { id: {
                required: true,
                serializedName: 'id',
                type: {
                    name: 'String',
                },
            } }),
    },
};
